import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, AddPerson, AddPerson2} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';





import aukrit from '../../Pictures/pics/aukrit.jpeg';
import azizuddin from '../../Pictures/pics/azizuddin.png';
import bala from '../../Pictures/pics/bala.jpeg';
import barak from '../../Pictures/pics/barak.jpg';
import barbara from '../../Pictures/pics/barbara.png';
import bikesh from '../../Pictures/pics/bikesh.jpeg';
import casper from '../../Pictures/pics/casper.jpg';
import jonathaneg from '../../Pictures/pics/jonathan.jpeg';
import justin from '../../Pictures/pics/justin.jpeg';
import kuo from '../../Pictures/pics/kuo.jpeg';
import michael from '../../Pictures/pics/michael.jpeg';
import nadia from '../../Pictures/pics/nadia.jpeg';
import naysan from '../../Pictures/pics/naysan.jpg';
import ned from '../../Pictures/pics/ned.jpeg';
import nizar from '../../Pictures/pics/nizar.png';
import paul from '../../Pictures/pics/Paul.jpeg';
import raghu from '../../Pictures/pics/raghu.jpg';
import shahira from '../../Pictures/pics/shahira.jpg';
import umar from '../../Pictures/pics/umar.png';

import jonathanoh from '../../Pictures/pics/jonathanoh.jpeg';
import jimmy from '../../Pictures/pics/jimmy.jpeg';
import syphong from '../../Pictures/pics/syphong.jpg';


import artie from '../../Pictures/pics/artie.png';
import nidhi from '../../Pictures/pics/nidhi.jpeg';



export class ChapterHundredThirteen extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">

        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>

        <TextHolder text="A group of 23 founders, venture capitalists and community builders within the tech space in Southeast Asia – selected for their years of experience – shared their insights with us. They are:" />


                <div className="block-outer">
                  <div className="block-inner block-inner-peopleholder">

                  <AddPerson src={ azizuddin } alt='AJ Azizuddin' position='Country Director' company='Mountain Partners' />

                  <AddPerson src={ bala } alt='A. Balasubramaniam' position='Head' company='Funding Ecosystem, Malaysia Digital Economy Corporation (MDEC)' />
                  <AddPerson src={ artie } alt='Artie Lopez' position='Co-Founder' company='Brainsparks' />
                  <AddPerson src={ aukrit } alt='Aukrit Unahalekhaka' position='Co-Founder and CEO' company='Ricult' />
                  <AddPerson src={ barbara } alt='Barbara Ximenez' position='Founder & CEO' company='Shutta' />


                  <AddPerson src={ barak } alt='Barak Sharabi' position='Chief Global Strategy' company='Infinity Technologies / SPARK Accelerator' />

                  <AddPerson src={ bikesh } alt='Bikesh Lakhmichand' position='Founder and CEO' company='1337 Ventures' />
                  <AddPerson src={ casper } alt='Casper Sermsuksan' position='Co-Founder' company='Kulina' />

                  <AddPerson src={ jimmy } alt='Jimmy How' position='Founder and CEO' company='Involve Asia' />
                  <AddPerson src={ jonathaneg } alt='Jonathan Eg' position='Founder and CEO' company='PARTIPOST' />
                  <AddPerson src={ jonathanoh } alt='Jonathan Oh' position='Founder & CEO' company='Supplycart' />
                  <AddPerson src={ justin } alt='Justin Nguyen' position='Justin Nguyen' company='CoFounder Venture Partners' />
                  <AddPerson src={ kuo } alt='Kuo-Yi Lim' position='Managing Partner' company='Monk’s Hill Ventures' />




                  <AddPerson src={ michael } alt='Michael Lints' position='Partner' company='Golden Gate Ventures' />

                  <AddPerson src={ nadia } alt='Nadia Jalil' position='Founder and CEO' company='MyBump' />
                  <AddPerson src={ naysan } alt='Naysan Munusamy' position='Co-Founder' company='MoneyMatch' />
                  <AddPerson src={ ned } alt='Ned Phillips' position='Founder and CEO' company='Bambu' />
                  <AddPerson src={ nidhi } alt='Nidhi Gupta' position='Co-Founder and CEO' company='Portcast' />
                  <AddPerson src={ nizar } alt='Nizar Ali' position='Managing Director' company='FirstFloor Capital' />


                  <AddPerson src={ paul } alt='Paul Hadjy' position='Co-Founder and CEO' company='Horangi' />
                  <AddPerson src={ raghu } alt='Raghu Rai' position='Founder and CEO' company='Jio Health' />
                  <AddPerson src={ shahira } alt='Shariha Khalid Erichsen' position='Managing Partner' company='Mission & Co and Board Member, Impact Hub Kuala Lumpur' />
                  <AddPerson src={ syphong } alt='Syphong Bui' position='Founder and CEO' company='OnOnPay' />

                <AddPerson src={ umar } alt='Umar Munshi' position='Founder' company='Ethis Ventures and CEO, Ethis Crowd' />




                <TextHolder text=""/>
                <TextHolder text=""/>
                <TextHolder textTitle="We'd also like to thank the following contributors:" />
                <TextHolder text=""/>
                <AddPerson2 alt='Anna Gong' position='CEO & Founder' company='Perx' />
                <AddPerson2 alt='Andree Susanto' position='CEO' company='Waresix' />
                <AddPerson2 alt='Veerapat Rungsithum' company='Bangkok Bank, Innohub Accelerator' />
                <AddPerson2 alt='A. Riaz Bhardwaj' position='Senior Associate & Ex-founder' company='ANGIN' />
                <AddPerson2 alt='Angky William' position='CTO' company='Stoqo' />
                <AddPerson2 alt='Elisabeth Kurniawan' position='Founder & CEO' company='TheShonet' />
                <AddPerson2 alt='Bianca Ho' position='Co-founder' company='Clare.AI' />
                <AddPerson2 alt='Barak Sharabi' position='Chief Global Strategy' company='Infinity Technologies / SPARK Accelerator' />
                <AddPerson2 alt='Niomal Liyanage' position='Chief Strategy Officer' company='Accelerate' />
                <AddPerson2 alt='Bobby Liu' position='Co-Director' company='Topica Founder Institute' />
                <AddPerson2 alt='Rifki Pratomo' position='Founder' company='Andalin' />
                <AddPerson2 alt='Karissa Adelaide' position='Investment Analyst' company='Spiral Ventures' />







                <TextHolder textTitle="In addition, we'd like to thank the following contributors for playing a major role in the writing and editing of the report: " />
                <TextHolder text=""/>

                <AddPerson2 alt='Reez Nordin' position='Monk´s Hill Ventures'/>
                <AddPerson2 alt='Michele Daoud' position='Monk´s Hill Ventures'/>
                <AddPerson2 alt='Nathalie Lagerfeld' position='Hippo Reads'/>
                <AddPerson2 alt='Lucy Spencer' position='Hippo Reads'/>
                <AddPerson2 alt='Jennifer Schaffer-Goddard' position='Hippo Reads'/>
                <AddPerson2 alt='Marijke Lints' position='Slush Singapore'/>
                <AddPerson2 alt='Veeti Huotari' position='Slush Singapore'/>
                <AddPerson2 alt='Jamaur Bronner' position='Consultant to Slush Singapore'/>

                <AddPerson2 alt='Grace Chng' position='Veteran tech writer, Former Senior Correspondent' company='The Straits Times'/>
                <AddPerson2 alt='Isabelle Solal' position='INSEAD' />







                  </div>
                  </div>



          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/113.js